import { useCallback, useState } from "react";
import { CrudClient } from "../../../api/CrudClient";
import { API_ROUTES } from "../../../api/routes";
import { AxiosError } from "axios";
import { toast } from "material-react-toastify";

export const useAddCardToDeck = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<AxiosError>();

  const addCardToDeck = useCallback(async (deckId: string, cardId: string) => {
    setError(undefined);
    setLoading(true);
    try {
      const { data } = await CrudClient.post(
        API_ROUTES.DECK_CARD(deckId, cardId)
      );
      setLoading(false);
      toast.success("Carta adicionada.");
      return data;
    } catch (e) {
      const error = e as AxiosError<any, any>;
      error.message = error.response?.data?.message || error.message;
      setError(e as any);
    }
    setLoading(false);
  }, []);

  return { error, addCardToDeck, loading };
};
